import SelectInput, { SelectOption } from "Components/molecule/inputs/select-input"
import FormContainer from "Components/atoms/containers/form-container"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import FormProps from "data/forms"
import UserFields from "./types"

const USER_STATUS_KEY = 'userStatusId'

interface UserFormProps extends FormProps<UserFields> {
    userStatuses: SelectOption[]
}

const UserForm = ({
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    isValid,
    touched,
    isSubmitting,
    edit,
    userStatuses
}: UserFormProps) => {

    return <FormContainer
        inputs={
            <SelectInput
                touched={!!touched.userStatusId}
                name={USER_STATUS_KEY}
                key={USER_STATUS_KEY}
                label={"Status*"}
                placeholder={"Select a status"}
                options={userStatuses}
                value={values.userStatusId}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.userStatusId && !!errors.userStatusId}
                message={touched.userStatusId ? errors.userStatusId : undefined}
            />
        }
        buttons={
            <PrimaryButton
                type='submit'
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
                className="w-100"
            >
                {isSubmitting ? "Submitting...." : edit ? "Update" : "Submit"}
            </PrimaryButton>
        }
    />
}

export default UserForm
